<template>
    <CompassTableRow :visible="visible" subrow>
        <template #subrow>
            <CompassTable displayEmptyExpandableColumn>
                <CompassTableHead>
                    <CompassTableHeadCell
                        v-for="column in subrowColumns"
                        :id="column.code"
                        :key="`objectives-listing-table__table-row-${rowId}-subrow-column-${column.code}`"
                        :alignContent="column.alignContent"
                    >
                        {{ column.label }}
                    </CompassTableHeadCell>
                </CompassTableHead>

                <CompassTableBody>
                    <CompassTableRow
                        v-for="(subrow, index) in subrows"
                        :key="`objectives-listing-table__table-row-${rowId}-subrow-${index}`"
                    >
                        <CompassTableBodyCell
                            v-for="column in subrowColumns"
                            :key="`objectives-listing-table__table-row-${rowId}-subrow-${index}-column-${column.code}`"
                            :fixed="column.fixed"
                            :minWidth="column.width"
                            :alignContent="column.alignContent"
                        >
                            <template v-if="column.code === 'progress'">
                                <ProgressBarWithTooltip
                                    v-bind="subrow.progress"
                                    class="objectives-listing-table__table-progress-bar"
                                />
                            </template>
                            <template v-else>
                                {{ subrow[column.code] }}
                            </template>
                        </CompassTableBodyCell>
                    </CompassTableRow>
                </CompassTableBody>
            </CompassTable>
        </template>
    </CompassTableRow>
</template>

<script>
import ProgressBarWithTooltip from 'vcomponents/listing/ProgressBar/ProgressBarWithTooltip.vue';

export default {
    components: {
        ProgressBarWithTooltip,
    },
    props: {
        rowId: {
            type: Number,
            required: true,
        },
        subrows: {
            type: Array,
            required: true,
        },
        subrowColumns: {
            type: Array,
            required: true,
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
